import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Spacer from 'components/Spacer'
import Button from 'components/Button'
import Row from 'components/Row'
import { get } from 'service/api'
import Modal from 'components/Modal'
import { maskValue } from 'utils/helpers'
import { setData } from 'store/reducers/info'
import Footer from 'components/Footer'
import H3 from 'components/H3'
import DbList from 'components/DbManagingList'
import Column from 'components/Column'

import Container, { ModalContainer } from './styles'
import ModalDatabases from './ModalDatabases'
import ModalHours from './ModalHours'
import ModalForm from './ModalForm'

export default function Login() {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const history = useHistory()
  const [values, setValues] = useState({})
  const [databaseModalOpen, setDatabaseModalOpen] = useState(false)
  const [hoursModalOpen, setHoursModalOpen] = useState(false)
  const [formModalOpen, setFormModalOpen] = useState(false)

  useEffect(() => {
    let mounted = true
    const find = async () => {
      let res = await get({ url: '/data' })
      if (mounted && res) {
        setValues(res)
      }
    }
    find()

    return () => (mounted = false)
  }, [])

  function toggleDatabaseModal() {
    setDatabaseModalOpen((open) => !open)
  }
  function toggleHoursModal() {
    setHoursModalOpen((open) => !open)
  }
  function toggleFormModal() {
    setFormModalOpen((open) => !open)
  }

  function handleNavigation(data) {
    dispatch(setData(data))
    history.push('/summary')
  }

  if (values.database) {
    return (
      <>
        <Modal show={databaseModalOpen}>
          <ModalContainer>
            <H3>{t('home.database.title')}</H3>
            <ModalDatabases
              values={values}
              onBuy={handleNavigation}
              onClose={toggleDatabaseModal}
            />
          </ModalContainer>
        </Modal>

        <Modal show={hoursModalOpen}>
          <ModalContainer>
            <H3>{t('home.hourly.title')}</H3>
            <ModalHours
              values={values}
              onBuy={handleNavigation}
              onClose={toggleHoursModal}
            />
          </ModalContainer>
        </Modal>

        <Modal show={formModalOpen}>
          <ModalContainer>
            <H3>{t('home.form.title')}</H3>
            <ModalForm onClose={toggleFormModal} />
          </ModalContainer>
        </Modal>

        <Container>
          <Spacer height={30} />
          <h1>{t('home.title')}</h1>
          <Spacer height={50} />

          <div className="content">
            <div className="content-item">
              <Row>
                <img
                  className="item-image"
                  src="/assets/images/db_preto.png"
                  alt={t('home.database.title')}
                />
                <Spacer width={10} />
                <div>
                  <H3>{t('home.database.title')}</H3>
                  <Spacer height={10} />
                  <p>{t('home.database.description')}</p>
                </div>
              </Row>
              <Spacer height={15} />

              <div>
                <DbList />
                <Spacer height={30} />
                <p className="content-item-highlight">
                  {t('home.database.highlight', {
                    value: maskValue(values.database.value),
                    additional: maskValue(values.database.additional),
                  })}
                </p>
                <Spacer height={30} />

                <Row justify="center">
                  <Button
                    label={t('button.simulate_buy')}
                    className="primary"
                    onClick={() => toggleDatabaseModal()}
                  />
                </Row>
              </div>
            </div>
            <div className="content-item">
              <Row>
                <img
                  className="item-image"
                  src="/assets/images/hourly_preto.png"
                  alt={t('home.hourly.title')}
                />
                <Spacer width={10} />
                <div>
                  <H3>{t('home.hourly.title')}</H3>
                  <Spacer height={10} />
                  <p>{t('home.hourly.description')}</p>
                </div>
              </Row>
              <Spacer height={15} />

              <div>
                <Row justify="center">
                  <table>
                    <thead>
                      <tr>
                        <th className="left">
                          {t('home.hourly.table.header.consulting')}
                        </th>
                        <th className="right">
                          {t('home.hourly.table.header.rate')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{t('home.hourly.table.four_hours')}</td>
                        <td className="right">
                          {maskValue(values.hourly.four)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t('home.hourly.table.eight_hours')}</td>
                        <td className="right">
                          {maskValue(values.hourly.eight)}
                        </td>
                      </tr>
                      <tr>
                        <td>{t('home.hourly.table.additional_hours')}</td>
                        <td className="right">
                          {maskValue(values.hourly.additional)}/h
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Row>

                <Spacer height={30} />

                <Row justify="center">
                  <Button
                    label={t('button.simulate_buy')}
                    className="primary"
                    onClick={() => toggleHoursModal()}
                  />
                </Row>
              </div>
            </div>
          </div>

          <Spacer height={30} />

          <div className="flex_wrap align_center justify_center">
            <Footer />
            <Spacer width={30} />

            <Column>
              <div>
                <button
                  className="icon_button"
                  type="button"
                  onClick={toggleFormModal}
                >
                  <img
                    className="item-image"
                    src="/assets/images/email.png"
                    alt={t('home.message')}
                  />
                  <span>{t('home.message')}</span>
                </button>
              </div>
              <div className="bold">
                <p>{t('home.call')}</p>
                <p>+1 385-287-8440</p>
              </div>
            </Column>
          </div>
          <Spacer height={30} />
        </Container>
      </>
    )
  }

  return ''
}
